import {
    TurnstileWidget,
    TurnstileRenderOptions,
    LibraryConfiguration,
} from '@indeed/bot-detection-Cloudflare-Turnstile-Library';

const turnstileRenderOptions: TurnstileRenderOptions = {
    sitekey: '0x4AAAAAAAxcdCS90IQZX-oi',
    theme: 'auto',
};

const libraryConfiguration: LibraryConfiguration = {
    application: 'indeedMobile',
    appPageName: 'resultsPage',
};

const turnstileWidget: TurnstileWidget = new TurnstileWidget(
    libraryConfiguration,
    turnstileRenderOptions
);

// @ts-ignore
window.resultsPageTurnstile = turnstileWidget;
